module.exports = __webpack_public_path__ + "static/media/pizza.c83192e4.png";